<template>
    <button type="button"
            class="sim-close-btn sim-menu-btn"
            :class="{
                'sim-close-btn--dark sim-ghost-btn-hover--dark': variant === 'dark',
            }"
            :aria-label="$t('labels.close')"
    >
        <IconCross size="xs" />
    </button>
</template>

<script lang="ts" setup>

const {
    variant = 'light',
} = defineProps<{
    variant?: 'light' | 'dark'
}>()

</script>

<style lang="scss" scoped>
$size: 1.5rem;

.sim-close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    //width: $size;
    //height: $size;
    padding: 0.75rem;
    margin: -0.5rem;
    flex-shrink: 0;
}

.sim-close-btn--dark {
    color: $sim-c-white;
}

</style>
